import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import StarIcon from '@mui/icons-material/StarBorder';
import Typography from '@mui/material/Typography';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import {withRouter} from "react-router";

const tiers = [
    {
        title: 'Free',
        price: '0',
        description: [
            '5 players',
            'Interactive grid display',
            'Admin dashboard',
            'Score control panel',
            'Players accounts not required',
            'Lots of fun',
        ],
        buttonText: 'Sign up for free',
        buttonVariant: 'outlined',
        buttonLink: '/create-grid',
    },
    {
        title: 'Pro',
        subheader: 'Most popular',
        price: '4.99',
        oldPrice: '9.99',
        description: [
            '100 players/grid',
            'Interactive grid display',
            'Admin dashboard',
            'Score control panel',
            'Players accounts not required',
            'Email support',
            'Lots of fun',
        ],
        buttonText: 'Get started',
        buttonVariant: 'contained',
        buttonLink: '/create-grid',
    },
    {
        title: 'Enterprise',
        price: ' 20 ',
        description: [
            '100 players/grid',
            'Interactive grid display',
            'Admin dashboard',
            'Score control panel',
            'Players accounts not required',
            'Custom links',
            'Password protection',
            'Customized page branding',
            'Leaderboard',
            'Phone & email support',
            'Lots of fun'
        ],
        buttonText: 'Contact us',
        buttonVariant: 'outlined',
        buttonLink: '/contact',
    },
];

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

function Pricing({history}) {
    return (
        <ThemeProvider theme={defaultTheme}>
            <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
            <CssBaseline />
            {/* Hero unit */}
            <Container disableGutters maxWidth="sm" component="main" sx={{ pt: 8, pb: 6 }}>
                <Typography
                    component="h1"
                    variant="h2"
                    align="center"
                    color="text.primary"
                    gutterBottom
                >
                    Pricing
                </Typography>
                <Typography variant="h5" align="center" color="text.secondary" component="p">
                    Manage your football squares pool in a  fun and interactive way.
                </Typography>
            </Container>
            {/* End hero unit */}
            <Container maxWidth="md" component="main">
                <Grid container spacing={5} alignItems="flex-end">
                    {tiers.map((tier) => (
                        // Enterprise card is full width at sm breakpoint
                        <Grid
                            item
                            key={tier.title}
                            xs={12}
                            sm={tier.title === 'Enterprise' ? 12 : 6}
                            md={4}
                        >
                            <Card>
                                <CardHeader
                                    title={tier.title}
                                    subheader={tier.subheader}
                                    titleTypographyProps={{ align: 'center' }}
                                    action={tier.title === 'Pro' ? <StarIcon color={"warning"}/> : null}
                                    subheaderTypographyProps={{
                                        align: 'center',
                                    }}
                                    sx={{
                                        backgroundColor: tier.title === 'Pro' ? "#1976d2" : "#cccccc"
                                            // (theme) =>
                                            // theme.palette.mode === 'light'
                                            //     ? theme.palette.grey[200]
                                            //     : theme.palette.grey[700],
                                    }}
                                />
                                <CardContent>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'baseline',
                                            mb: 2,
                                        }}
                                    >
                                        {tier.oldPrice ? (<Typography component="h4" variant="h5" color="text.primary" style={{textDecorationLine: 'line-through'}}>
                                            ${tier.oldPrice}
                                        </Typography>) : null}<Typography component="h2" variant="h3" color="text.primary">
                                            ${tier.price}
                                        </Typography>
                                        <Typography variant="h6" color="text.secondary">
                                            /grid
                                        </Typography>
                                    </Box>
                                    <ul>
                                        {tier.description.map((line) => (
                                            <Typography
                                                component="li"
                                                variant="subtitle1"
                                                align="center"
                                                key={line}
                                            >
                                                {line}
                                            </Typography>
                                        ))}
                                    </ul>
                                </CardContent>
                                <CardActions>
                                    <Button onClick={() => history.push(`${tier.buttonLink}`)} fullWidth variant={tier.buttonVariant}>
                                        {tier.buttonText}
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </ThemeProvider>
    );
}

export default withRouter(Pricing);
